import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import 'primeicons/primeicons.css';
import Alertas from "../../alertas";

function Providencias({ setFraseTopo, setStage, providencias, outraProvidencia, motivos, outroMotivo, setProvidencias, setOutraProvidencia, setMotivos, setOutroMotivo }) {

    const opcoesProvidencias = [
        { key: '1', name: 'Solicitou medidas protetivas de urgência da Lei Maria da Penha' },
        { key: '2', name: 'Denunciou em uma delegacia da mulher' },
        { key: '3', name: 'Procurou a Defensoria Pública' },
        { key: '4', name: 'Procurou ajuda da família' },
        { key: '5', name: 'Procurou ajuda dos(as) amigos(as)' },
        { key: '6', name: 'Denunciou em uma delegacia comum' },
        { key: '7', name: 'Procurou a igreja que frequenta' },
        { key: '8', name: 'Ligou para a Polícia Militar no 190' },
        { key: '9', name: 'Ligou para a Central de Atendimento à Mulher (Ligue 180)' },
        { key: '10', name: 'Procurou uma associação ou entidade de proteção à mulher (ONG)' },
        { key: '11', name: 'Não fez nada' },
        { key: '12', name: 'Outros' },
    ];

    const opcoesMotivos = [
        { key: '1', name: 'Fui ameaçada e tive medo de ser agredida ou ser morta caso eu terminasse a relação' },
        { key: '2', name: 'Meu(s)/minha(s) filhos(as) foram ameaçados(as) e tive medo que eles(as) fossem machucados(as) ou mortos(as) caso eu terminasse a relação' },
        { key: '3', name: 'Tive vergonha de que outras pessoas soubessem que eu estava sofrendo violência' },
        { key: '4', name: 'Sempre acreditava que ele(a) se arrependia das agressões (físicas e verbais/ofensas) e que não voltaria a me machucar/ofender' },
        { key: '5', name: 'Acreditei que o amor e os(as) filhos(as) mudariam o comportamento dele(a)' },
        { key: '6', name: 'Dependia financeiramente dele(a) e achava que se me separasse não ia ter condições de me sustentar ou aos(as) filhos(as) sem ele(a)' },
        { key: '7', name: 'Acreditava que não seria levada a sério na Delegacia de Polícia que os meus direitos envolvendo pensão alimentícia, guarda e partilha de bens demorariam muito para ser resolvidos no sistema de justiça' },
        { key: '8', name: 'Fui chantageada com ameaças de escândalos (mentiras, divulgação fotos/vídeos íntimos etc.) na família/trabalho' },
        { key: '9', name: 'Achava que era normal que todo relacionamento tivesse ofensas e agressões físicas' },
        { key: '10', name: 'Ele ameaçava que ia ficar com a guarda dos(as) filhos(as) se eu terminasse o relacionamento' },
        { key: '11', name: 'Ele ameaçava que ia tirar a própria vida se eu terminasse o relacionamento' },
        { key: '12', name: 'Resolvi sozinha' },
        { key: '13', name: 'Não queria envolver a polícia' },
        { key: '14', name: 'Achei que não tinha provas para denunciar' },
        { key: '15', name: 'Não achei que era importante' },
        { key: '16', name: 'Outros' },
    ];

    useEffect(() => {
        setFraseTopo("A violência não define quem você é.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const onProvidenciasChange = (e) => {
        let _selectedCategories = [...providencias];

        if (e.checked)
            _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(category => category.key !== e.value.key);

        setProvidencias(_selectedCategories);
    };

    function verificacao(step) {
        if (providencias.some((item) => item.key == "12")) {
            if (outraProvidencia) {
                if (motivos.some((item) => item.key == "16")) {
                    if (outroMotivo) {
                        setStage(step)
                    } else {
                        Alertas.atencao('Adicione a descrição na opção "Outros".');
                    }
                } else {
                    setStage(step)
                }
            } else {
                Alertas.atencao('Adicione a descrição na opção "Outros".');
            }
        } else {
            if (motivos.some((item) => item.key == "16")) {
                if (outroMotivo) {
                    setStage(step)
                } else {
                    Alertas.atencao('Adicione a descrição na opção "Outros".');
                }
            } else {
                setStage(step)
            }
        }
    }


    const onMotivosChange = (e) => {
        let _selectedCategories = [...motivos];

        if (e.checked)
            _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(category => category.key !== e.value.key);

        setMotivos(_selectedCategories);
    };

    return (
        <div className="app-main-mulher">
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Você adotou alguma providência em relação às violências sofridas? </strong></p>
                        <p><strong>Marque TODAS que se aplicam</strong></p>

                        <div>
                            {opcoesProvidencias.map((category) => {
                                return (
                                    <div key={category.key} className="item-check-mulher">
                                        <Checkbox inputId={category.key} name="category" value={category} onChange={onProvidenciasChange} checked={providencias.some((item) => item.key === category.key)} />
                                        <label htmlFor={category.key} className="ml-2">
                                            {category.name}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                        {
                            providencias.some((item) => item.key == "12") ?
                                <div className="card-form-a">
                                    <p className="labels">Outros <span className="pink">*</span> </p>
                                    <InputText value={outraProvidencia} onChange={(e) => setOutraProvidencia(e.target.value)} />
                                </div>
                                :
                                <div className="card-form-a desativado">
                                    <p className="labels">Outros <span className="pink">*</span> </p>
                                    <InputText disabled value={outraProvidencia} />
                                </div>
                        }
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Quais motivos que levaram você a tomar a decisão de não denunciar: </strong></p>
                        <p><strong>Marque TODAS que se aplicam</strong></p>

                        <div>
                            {opcoesMotivos.map((category) => {
                                return (
                                    <div key={category.key} className="item-check-mulher">
                                        <Checkbox inputId={category.key} name="category" value={category} onChange={onMotivosChange} checked={motivos.some((item) => item.key === category.key)} />
                                        <label htmlFor={category.key} className="ml-2">
                                            {category.name}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                        {
                            motivos.some((item) => item.key == "16") ?
                                <div className="card-form-a">
                                    <p className="labels">Outros <span className="pink">*</span> </p>
                                    <InputText value={outroMotivo} onChange={(e) => setOutroMotivo(e.target.value)} />
                                </div>
                                :
                                <div className="card-form-a desativado">
                                    <p className="labels">Outros <span className="pink">*</span> </p>
                                    <InputText disabled value={outroMotivo} />
                                </div>
                        }
                    </div>
                </div>
            </div>


            <div className="card-rodape-mulher">
                <Button
                    label="Voltar"
                    className="btn-1-mulher"
                    onClick={() => verificacao(3)}
                />
                <Button
                    style={{ marginLeft: "10px" }}
                    label="Próximo"
                    className="btn-1-mulher"
                    onClick={() => verificacao(5)}
                />
            </div>
        </div>

    );
}

export default Providencias;
